// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Styles from "../../styles/components/Styles.bs.jsx";
import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";
import * as JsxRuntime from "react/jsx-runtime";
import UnauthenticatedTemplateModuleCss from "./UnauthenticatedTemplate.module.css";

let classes = UnauthenticatedTemplateModuleCss;

function UnauthenticatedTemplate(props) {
  return <div
    aria-hidden={props.loadingOverlay}
    className={Styles.page.centered + ` ` + classes.root + ` ` + Stdlib_Option.getOr(props.className, "")}
  >
    <h1
      className={Styles.utility.srOnly}
    >
      {"Check.beer"}
    </h1>
    {props.isOnline !== false ? null : <p
        className={Styles.messageBar.variantDanger}
      >
        {"Vypadá to že jsme bez internetu. Přihlášení ani registrace asi nepůjde."}
      </p>}
    {props.children}
  </div>;
}

let make = UnauthenticatedTemplate;

export {
  classes,
  make,
}
/* classes Not a pure module */
